/**
 * @desc 确认并提交包裹
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(body: defs.omsFlow.DetachablePackageRpcDto, options?: any) {
  return updateResponse(
    http(URL + `/rpc/systemOrderPackage/detachablePackage`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
